import { importAll } from '@/utils'

// 注册 最小元素组件；
export function registerItemComps (path) {
  const comps = {}
  importAll(require.context(path, true, /\.vue$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
    if (keyPath.includes('index')) {
      let keyP = keyPath.split('/')[0]
      comps[keyP] = r(key).default ? r(key).default : r(key)
    }
  })
  return comps
}

function _getWebpack () {
  const TmpMap = {}
  importAll(require.context('./', true, /\.vue$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
    const keyPathList = keyPath.split('/')
    let [KP1, KP2, KP3] = keyPathList
    TmpMap[KP1] = TmpMap[KP1] || {}
    // console.log('_getWebpack()：keyPathList',keyPathList)
    if (keyPath.includes('index')) {
      TmpMap[KP1]['tmps'] = TmpMap[KP1]['tmps'] || {}
      TmpMap[KP1]['tmps'][KP2] = r(key).default ? r(key).default : r(key)
    }
    // if (keyPath.includes('props')) {
    //   TmpMap[KP1]['props'][KP2] = r(key).default ? r(key).default : r(key)
    // }
    if (KP2 == 'comps') {
      if (keyPath.includes('index')) {
        TmpMap[KP1]['comps'] = TmpMap[KP1]['comps'] || {}
        TmpMap[KP1]['comps'][KP3] = r(key).default ? r(key).default : r(key)
      }
    }
  })
  importAll(require.context('./', true, /\.js$/), (key, r) => {
    const keyPath = key.match(/\.\/(.+)\.js$/)[1]
    const keyPathList = keyPath.split('/')
    let [KP1, KP2, KP3] = keyPathList
    TmpMap[KP1] = TmpMap[KP1] || {}
    if (!['config'].includes(keyPath)) {
      TmpMap[KP1]['config'] = TmpMap[KP1]['config'] || {}
      TmpMap[KP1]['config'][KP2] = (r(key).default ? r(key).default : r(key)).config
      !TmpMap[KP1]['config'][KP2] && delete TmpMap[KP1]['config'][KP2]
    }
  })
  console.log('TmpMap', TmpMap)
  return TmpMap
}

export const TmpPackage = _getWebpack()
